module.exports = __webpack_public_path__ + "static/media/Benifits4.0c2c6b76.webp";